module.exports = __webpack_public_path__ + "img/custom.2a291b8e.png";